var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleWithMountains(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 92,
    viewBox: "0 0 273 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M152.147 43.0235C180.077 43.9598 189.555 53.1772 207.37 57.505C209.096 57.8916 210.856 58.1591 212.634 58.3047C253.25 62.3609 264.154 80.777 272.5 92H0.5C25.4528 87.2003 22.4199 57.6024 65.1319 55.4657C89.5154 54.2465 118.011 42.4036 152.147 43.0235Z",
    fill: "url(#paint0_linear_8242_146401)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8242_146401)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M116.879 67C126.843 67 134.92 66.1686 134.92 65.143C134.92 64.1175 126.843 63.2861 116.879 63.2861C106.916 63.2861 98.8389 64.1175 98.8389 65.143C98.8389 66.1686 106.916 67 116.879 67Z",
    fill: "#1386A0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M115.983 17.0081C116.376 17.9411 118.969 20.6959 123.118 20.8608C128.917 21.0914 134.129 15.9742 135.141 13.7081C136.152 11.4419 136.775 12.9277 135.622 15.4978C134.264 18.5214 129.985 25.0129 124.098 24.8862C119.008 24.7762 113.084 21.1311 113.084 21.1311C113.084 21.1311 113.092 18.445 115.983 17.0081Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.35 36.1041C116.35 36.1041 118.474 45.2192 117.748 48.3115C116.244 54.7129 107.109 62.982 107.803 63.4401C108.498 63.8982 111.173 64.1472 109.947 64.3258C108.72 64.5045 105.721 64.8863 106.013 63.9624C106.505 62.3635 112.726 50.5731 112.371 47.9389C112.016 45.3047 108.329 35.8583 108.329 35.8583C108.329 35.8583 114.181 34.1037 116.35 36.1041Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.732 35.5537C116.732 35.5537 129.485 40.4739 128.92 45.6965C128.519 49.3614 121.968 58.5956 122.552 59.3011C123.135 60.0066 124.625 61.155 124.857 61.61C125.088 62.0651 120.69 59.4905 120.69 59.4905L124.997 46.712L108.818 37.5649C111.35 36.5287 114.013 35.8517 116.732 35.5537Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.046 7.82217C110.046 7.82217 112.771 3.75712 115.98 5.84768C119.189 7.93823 117.86 13.6357 114.4 13.9411C110.94 14.2465 108.185 10.4441 110.046 7.82217Z",
    fill: "#F4A300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.184 18.6147L117.384 17.8008C117.384 17.8008 116.668 14.1068 116.889 12.3797C117.041 11.1795 113.497 9.66309 113.497 9.66309L114.184 18.6147Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.525 6.86173C116.525 6.86173 119.624 11.7117 117.22 13.564C115.696 14.7383 112.163 10.2365 112.185 8.83011C112.206 7.42369 116.05 5.59426 116.525 6.86173Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.5 10.9148C113.5 10.9148 112.394 9.96345 112.281 10.7041C112.168 11.4447 113.5 12.3472 113.82 11.9257C114.14 11.5043 113.5 10.9148 113.5 10.9148Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.468 6.44721C116.468 6.44721 114.502 6.12348 114.23 8.71949C113.936 11.5171 111.432 10.6451 111.432 10.6451C111.432 10.6451 109.849 5.84861 116.468 6.44721Z",
    fill: "#F4A300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.005 10.5611C110.005 10.5611 109.537 9.89678 109.091 9.74713C106.868 8.99275 106.211 13.1235 103.356 10.2999C101.833 8.79118 101.249 9.2829 98.0404 12.0942C96.6296 13.3357 96.3127 10.7947 95.8054 11.2788C94.6916 12.3477 96.7347 17.0969 100.448 14.1802C102.099 12.8807 101.581 15.1606 104.686 15.7928C108.789 16.6296 111.097 12.8135 110.005 10.5611Z",
    fill: "#F4A300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.075 61.7261L106.013 60.2693C106.013 60.2693 112.322 49.0652 112.127 48.3108C111.932 47.5564 109.689 39.4844 109.689 39.4844L117.714 40.2846C117.714 40.2846 118.904 45.6965 117.714 49.618C116.803 52.6324 109.075 61.7261 109.075 61.7261Z",
    fill: "#F46277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.35 41.823C116.35 41.823 107.318 41.339 108.321 35.8583C109.025 32.0147 114.315 32.6836 115.247 33.2287C116.179 33.7739 117.346 41.3481 116.35 41.823Z",
    fill: "#FF8092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.219 55.8234L124.155 57.0725C124.155 57.0725 129.488 48.9088 129.488 45.6974C129.488 39.5891 116.233 34.3223 116.233 34.3223L111.312 39.6869C111.312 39.6869 123.992 45.363 124.122 46.5006C124.239 47.6016 121.219 55.8234 121.219 55.8234Z",
    fill: "#FF8092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.088 17.5469C114.088 17.5469 120.731 19.6222 120.391 21.7112C119.346 28.1401 117.801 35.0089 117.801 35.0089C117.801 35.0089 108.78 35.128 108.984 34.3217C109.581 31.9914 112.778 17.5469 114.088 17.5469Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.409 17.5469C115.409 17.5469 117.609 18.9854 118.569 18.9213C119.529 18.8571 119.392 16.7314 119.392 16.7314C119.392 16.7314 120.984 17.495 120.674 19.0892C120.45 20.2437 121.553 20.6514 121.656 23.4398C121.689 24.3561 120.412 26.0206 120.211 26.9918C119.503 30.4246 119.503 31.1347 119.503 31.1347C119.503 31.1347 111.266 30.1879 109.295 28.244C109.295 28.244 110.666 19.8008 113.186 17.5545C113.863 16.9498 115.409 17.5469 115.409 17.5469Z",
    fill: "#423A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.497 17.205C115.157 17.4799 118.712 17.3837 121.969 15.4687C127.283 12.3428 129.342 4.2219 129.13 1.4457C128.918 -1.33051 131.094 0.0514851 130.397 4.22495C129.87 7.37682 128.461 16.6324 123.927 19.6162C119.393 22.6001 113.212 21.7083 113.212 21.7083C113.212 21.7083 111.636 20.3095 113.497 17.205Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.631 17.1267C113.631 17.1267 117.414 16.8747 117.982 16.7266C117.982 16.7266 119.353 21.6437 119.353 21.94C119.353 22.2362 114.699 23.8396 113.465 22.9539C112.231 22.0682 111.825 17.8031 113.631 17.1267Z",
    fill: "#423A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.513 17.0081C158.12 17.9411 155.527 20.6959 151.378 20.8608C145.58 21.0914 140.367 15.9742 139.356 13.7081C138.344 11.4419 137.721 12.9277 138.874 15.4978C140.232 18.5214 144.511 25.0129 150.399 24.8862C155.489 24.7762 161.412 21.1311 161.412 21.1311C161.412 21.1311 161.405 18.445 158.513 17.0081Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.498 17.6953C160.498 17.6953 153.855 19.7706 154.195 21.8596C155.24 28.2886 156.785 35.1573 156.785 35.1573C156.785 35.1573 165.806 35.2764 165.602 34.4686C165.009 32.1383 161.813 17.6953 160.498 17.6953Z",
    fill: "#F2B7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.312 10.5957C156.312 10.5957 155.245 8.27457 156.345 6.4818C157.445 4.68902 158.157 5.7992 158.814 5.52738C160.368 4.88754 162.336 4.72873 163.77 6.75972C165.203 8.79072 162.878 9.42445 163.832 9.92228C164.786 10.4201 165.717 10.3697 165.001 11.8143C164.285 13.2589 162.331 12.4694 162.331 13.2986C162.331 14.1278 162.135 15.2472 160.351 15.2334C158.396 15.2181 155.162 13.8835 156.312 10.5957Z",
    fill: "#68504A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.299 18.0187L157.192 18.0676C157.192 18.0676 157.604 14.5889 157.241 12.7427C156.99 11.46 160.703 9.56641 160.703 9.56641L160.299 18.0187Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.912 6.86248C156.912 6.86248 153.975 12.3477 156.72 14.1435C158.46 15.2827 162.296 11.4421 161.748 8.62471C161.471 7.13429 157.317 5.45758 156.912 6.86248Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.452 7.85299C156.452 7.85299 157.255 6.02968 157.946 7.26507C158.614 8.46535 159.533 7.59645 160.644 7.80566C161.754 8.01486 161.04 11.211 160.987 11.2935C160.933 11.3759 162.758 9.78931 162.795 8.56613C162.832 7.34295 161.828 6.7703 160.313 6.08618C158.799 5.40205 156.422 5.80214 156.452 7.85299Z",
    fill: "#68504A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.134 11.1017C161.134 11.1017 162.246 9.98539 162.436 10.7718C162.627 11.5583 161.253 12.6455 160.879 12.2164C160.506 11.7873 161.134 11.1017 161.134 11.1017Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M158.46 67C168.424 67 176.501 66.1686 176.501 65.143C176.501 64.1175 168.424 63.2861 158.46 63.2861C148.497 63.2861 140.42 64.1175 140.42 65.143C140.42 66.1686 148.497 67 158.46 67Z",
    fill: "#1386A0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M158.241 36.2516C158.241 36.2516 156.117 45.3651 156.844 48.4574C158.348 54.8604 167.483 63.1279 166.787 63.5876C166.09 64.0472 163.418 64.2946 164.645 64.4718C165.871 64.6489 168.871 65.0337 168.586 64.1098C168.094 62.511 161.873 50.7205 162.228 48.0848C162.583 45.4491 166.27 36.0057 166.27 36.0057C166.27 36.0057 160.404 34.2511 158.241 36.2516Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.86 35.7012C157.86 35.7012 145.106 40.6199 145.679 45.8455C146.08 49.5104 152.631 58.7446 152.047 59.4501C151.464 60.1556 149.974 61.3024 149.739 61.7575C149.505 62.2126 153.906 59.6395 153.906 59.6395L149.399 46.296L165.773 37.7184C163.242 36.681 160.578 36.002 157.86 35.7012Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.516 61.8751L168.573 60.4167C168.573 60.4167 162.264 49.2142 162.459 48.4583C162.654 47.7024 164.897 39.6318 164.897 39.6318L156.871 40.432C156.871 40.432 155.683 45.8455 156.871 49.767C157.788 52.7814 165.516 61.8751 165.516 61.8751Z",
    fill: "#0C86BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.241 41.9698C158.241 41.9698 167.272 41.4873 166.27 36.0143C165.566 32.1706 160.276 32.838 159.344 33.3847C158.411 33.9313 157.244 41.4964 158.241 41.9698Z",
    fill: "#2095D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.371 55.9714L150.435 57.2205C150.435 57.2205 145.103 49.0568 145.103 45.8454C145.103 39.7371 158.357 34.4688 158.357 34.4688L163.279 39.8333C163.279 39.8333 150.603 45.5064 150.475 46.6486C150.348 47.7496 153.371 55.9714 153.371 55.9714Z",
    fill: "#2095D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.186 17.6953C159.186 17.6953 156.986 19.1323 156.026 19.0697C155.066 19.0071 155.203 16.8799 155.203 16.8799C155.203 16.8799 153.611 17.6434 153.92 19.2377C154.144 20.3921 153.041 20.7983 152.939 23.5883C152.906 24.5045 154.182 26.1675 154.382 27.1387C155.092 30.5716 155.72 35.168 155.72 35.168C155.72 35.168 164.823 38.0236 166.804 36.0812C166.804 36.0812 163.929 19.9432 161.412 17.6953C160.729 17.0906 159.186 17.6953 159.186 17.6953Z",
    fill: "#F46277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 17.205C159.339 17.4799 155.785 17.3837 152.527 15.4687C147.213 12.3428 145.155 4.2219 145.367 1.4457C145.578 -1.33051 143.4 0.0514851 144.102 4.22495C144.629 7.37682 146.038 16.6324 150.573 19.6162C155.107 22.6001 161.288 21.7083 161.288 21.7083C161.288 21.7083 162.86 20.3095 161 17.205Z",
    fill: "#B58A78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.965 17.2751C160.965 17.2751 157.182 17.0231 156.613 16.875C156.613 16.875 155.242 21.7921 155.242 22.0884C155.242 22.3847 159.897 23.9881 161.129 23.1008C162.362 22.2136 162.766 17.9501 160.965 17.2751Z",
    fill: "#FF8092"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8242_146401",
    x1: 136.379,
    y1: 47.3269,
    x2: 136.439,
    y2: 79.3875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1EBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D2EBF4",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D5EDF5",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#D9EEF6",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DFF1F7",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E7F5F9",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F1F9FC",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FCFEFE",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8242_146401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 67,
    fill: "white",
    transform: "translate(95.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleWithMountains);
export default __webpack_public_path__ + "static/media/People_with_mountains.dbf3d004f8c345eb37bae4cbf1bbc27c.svg";
export { ForwardRef as ReactComponent };